import { Component, OnInit, inject } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { MaskService } from '../../../services/mask.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FormService } from '../../form-service.service';

import { MaskitoDirective } from '@maskito/angular';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-form-currency-exp',
  styleUrls: ['form-currencyExp.component.scss'],
  template: `
    @if (props.label) {
      <label
        for="currency-exp-{{ field.id }}"
        class="section w-100"
        tabindex="0"
        [class.mat-error]="formControl.errors && formControl.touched"
        [innerHTML]="props.label"
      >
        @if (props.required) {
          <sup>*</sup>
        }
      </label>
    }
    @if (props.prompt) {
      <p
        class="explanation"
        tabindex="0"
        [class.mat-error]="formControl.errors && formControl.touched"
        [innerHTML]="props.prompt"
      ></p>
    }

    <mat-form-field floatPlaceholder="auto" class="w-100">
      <mat-label>{{ props.placeholder }}</mat-label>
      <input
        id="currency-exp-{{ field.id }}"
        matInput
        attr.maxlength="20"
        [maskito]="dollarMask"
        [placeholder]="props.placeholder"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [required]="props.required"
        [defaultValue]="formControl.value || ''"
      />
      @if (props.help) {
        <span
          matTooltip="{{ props.help }}"
          aria-label="help"
          tabindex="0"
          [matTooltipPosition]="'above'"
          [matTooltipClass]="'rb-tooltip'"
        >
          <mat-icon class="col-1 help-icon"> help </mat-icon>
        </span>
      }
      @if (
        formControl.hasError('required') && !formControl.hasError('regRequired')
      ) {
        <mat-error> This field is required </mat-error>
      }
      @if (formControl.hasError('regRequired')) {
        <mat-error>
          This field is needed for suitability review. You can opt out below if
          the applicant refuses to provide the information.
        </mat-error>
      }
    </mat-form-field>
  `,
  imports: [
    FormlyModule,
    MaskitoDirective,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    ReactiveFormsModule,
  ],
})
export class FormlyCustomCurrencyExpComponent
  extends FieldType
  implements OnInit
{
  mask = inject(MaskService);
  private formSvc = inject(FormService);

  dollarMask;
  unsubscribe = new Subject();

  constructor() {
    super();
    this.dollarMask = this.mask.dollarMaskSpecs();
  }

  ngOnInit(): void {
    this.field.form.valueChanges
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(() => {
        if (this.formSvc.getNeedToUpdateCalc()) {
          this.formSvc.setUpdateExternalCalcValue({
            source: 'formCurrencyExp',
          });
        }
      });
  }
}
